
const DashboardText = () => {
    return (
        <div>
            <h1 className="text-center text-2xl sm:text-4xl pt-5 text-gray-400 font-medium">
                Admin Dashboard
            </h1>
        </div>
    )
}

export default DashboardText;